$(document).ready(function Investment() {
	var $lastDetailsFilter = null;
	var $lastDetailsModal = null;
	var lastIdentifier = null;
	var filterData = {};
	
	var $filterable;
	var $filterableJq = [];
	var $noResults;
	var $tablesContainer = $('.investment-objects__table-container');
	
	var $detailsContainer = $('.investment-side-container');
	
	var $plansContainer = $('.investment-plan-container');
	var mainPlan = null;
	var housePlan = null;
	var withFlatsPlan = null;
	var floorPlan = null;
	var flatPlan = null;
	
	var activeWithFlatsId = null;
	var activeFloorId = null;
	var activeFlatId = null;
	
	var activeHouseId = null;
	
	var planData;
	
	var initGallery = function() {
		var perPage = 6;
		var allGroups = 0;
		var groups = [];
		var $next;
		var $prev;
		var currentPage = 0;
		var animating = false;
		var preparePages = function($container) {
			var $groupsContainer = $container.find('.investment-images__groups-container');
			var $images = $container.find('.investment-images__image-container');
			var $group = $group = $('<div class="investment-images__group investment-images__group--hidden"></div>');
			var splitAfter = perPage-1;
			var elementsInGroup = 0;
			for(var i = 0, s = $images.length; i < s; ++i) {
				$group.append($images[i]);
				$($images[i]).find('.investment-images__image img').click(zoom);
				elementsInGroup++;
				if(i%perPage == splitAfter) {
					allGroups++;
					$group.hide();
					$groupsContainer.append($group);
					groups.push($group);
					$group = $('<div class="investment-images__group investment-images__group--hidden"></div>');
					elementsInGroup = 0;
				}
			}
			$group.hide();
			
			if(elementsInGroup > 0) {
				$groupsContainer.append($group);
				groups.push($group);
				allGroups++;
			}
			
			groups[0].removeClass('investment-images__group--hidden');
			groups[0].show();
			if(allGroups > 1) {
				$next = $('<span class="investment-images__nav investment-images__nav--next" />');
				$prev = $('<span class="investment-images__nav investment-images__nav--prev" />');
				$groupsContainer.append($prev);
				$groupsContainer.append($next);
				$prev.click(prev);
				$next.click(next);
				tryDisableNav();
			}
		};
		
		var tryDisableNav = function() {
			if(!groups[currentPage+1]) {
				$next.addClass('investment-images__nav--disabled');
			} else {
				$next.removeClass('investment-images__nav--disabled');
			}
			
			if(!groups[currentPage-1]) {
				$prev.addClass('investment-images__nav--disabled');
			} else {
				$prev.removeClass('investment-images__nav--disabled');
			}
		};
		
		var change = function($current, $next) {
			var currentHeight = $current.height();
			var nextHeight;
			animating = true;
			
			$current.addClass('investment-images__group--hidden');
			onAnimationEnd($current, function() {
				$current.hide();
				$next.show();
				nextHeight = $next.height();
				if(currentHeight != nextHeight) {
						$next.height(currentHeight);
						$next.animate({height: nextHeight}, 200, function() {
							$next.removeClass('investment-images__group--hidden');
							onAnimationEnd($next, function() {
								animating = false;
							});
						})
				} else {
					$next.removeClass('investment-images__group--hidden');
					onAnimationEnd($next, function() {
						animating = false;
					});
				}
			});
		};
		
		var zoom = function() {
			var $content = $('<div class="modal-image-zoom"></div>');
			var $modal;
			$content.append($(this).clone());
			$modal = modalHelper.prepareTemplate($content);
			modalHelper.open($modal);
		};
		
		var next = function() {
			if(!animating && groups[currentPage+1]) {
				change(groups[currentPage], groups[currentPage+1]);
				currentPage++;
				tryDisableNav();
			}
		};
		
		var prev = function() {
			if(!animating && groups[currentPage-1]) {
				change(groups[currentPage], groups[currentPage-1]);
				currentPage--;
				tryDisableNav();
			}
		};
		
		var $container = $('.investment-images');
		if($container.length > 0) {
			preparePages($container);
		}
	};
	
	var initMap = function() {
		var prepareMap = function($container) {
			var point;
			var center;
			var map;
			var marker;
			var infowindow;
			
			point = {lat: parseFloat($container.data('latitude')), lng: parseFloat($container.data('longitude'))};
			
			center = {
				lat: point.lat,
				lng: point.lng
			};
			center.lat += 0.003;
			
			map = new google.maps.Map($container.get(0), {
			    center: center,
			    zoom: 13
		    });
			
			marker = new google.maps.Marker({
				position: point,
				map: map,
				title: $container.data('name')
			});
			
			infowindow = new google.maps.InfoWindow({
				content: '<b>'+$container.data('name')+'</b>'
			});
			
			infowindow.open(map, marker);
			
			$container.click(function() {
				return false;
			})
			
			$container.data('map', {
				recenter: function() {
					map.setCenter(center)
				}
			});
		};
		
		var $map = $('.investment-localization__map');
		if($map.length > 0) {
			prepareMap($map);
		}
	};
	
	var closeDetails = function(ignorePlans) {
		if($lastDetailsFilter) {
			if(true === $lastDetailsFilter.is(':visible')) {
				$lastDetailsFilter.addClass('investment-details--desktop-hidden');
				onAnimationEnd($lastDetailsFilter, function() {
					this.remove();
				}.bind($lastDetailsFilter));
			} else {
				$lastDetailsFilter.remove();
			}
		}
		if($lastDetailsModal) {
			modalHelper.close($lastDetailsModal);
		}
		
		if(null !== mainPlan) {
			mainPlan.unmark();
		}
		
		if(null !== housePlan) {
			housePlan.unmark();
		}
		
		if(null !== withFlatsPlan) {
			withFlatsPlan.unmark();
		}
		
		if(null !== floorPlan) {
			floorPlan.unmark();
		}
		
		$lastDetailsFilter = null;
		$lastDetailsModal = null;
		lastIdentifier = null;
		updateHash('');
		if(!ignorePlans) {
			removeAllPlans();
		}
	};
	
	var openDetails = function(id, responseText) {
		lastIdentifier = id;
		var $new = $(responseText);
		
		if(null !== $lastDetailsFilter) {
			$lastDetailsFilter.addClass('investment-details--desktop-hidden');
			onAnimationEnd($lastDetailsFilter, function() {
				this.remove();
			}.bind($lastDetailsFilter));
		}
		$new.addClass('investment-details--desktop-hidden');
		$new.addClass('investment-details--desktop');
		
		$new.find('.investment-details__open-plan-btn').addClass('investment-details__open-plan-btn--hidden').click(function() {
			$(this).addClass('investment-details__open-plan-btn--hidden');
			showOnPlan();
		});
		$new.find('.investment-details__btn--close').click(closeDetails);
		$new.find('.investment-details__btn--list').click(function() {
			if(_INVESTMENT_TYPE === 'house') {
				navHelper.goToElement($('[data-name="'+lastIdentifier+'"]'));
			} else if(_INVESTMENT_TYPE === 'withFlats') {
				navHelper.goToElement($('[data-path="'+lastIdentifier+'"]'));
			}
		});
		$detailsContainer.append($new);
		$new.outerWidth();
		$new.removeClass('investment-details--desktop-hidden');
		$lastDetailsFilter = $new;
		
		$new = modalHelper.prepareTemplate(responseText);
		$new.addClass('modal-container--only-mobile');
		$new.find('.investment-details__open-plan-btn').addClass('investment-details__open-plan-btn--hidden').click(showOnPlan);
		$new.on('modal.opened', function() {
			if(false === $new.is(':visible')) {
				navHelper.goToElement($detailsContainer);
			}
		}.bind($new));
		$new.on('modal.close', function() {
			closeDetails()
		});
		$lastDetailsModal = $new;
		modalHelper.open($new);
		updateHash('details/'+id);
	};

	var getHouseDetails = function(id, source) {
		$.get(_BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'/'+id).then(function(responseText) {
//			mainPlan.show(false, function() {
//				mainPlan.select('building-'+id);
//			});
			mainPlan.select('building-'+id);
//			mainPlan.show();
			
			openDetails(id, responseText);
		})
		.catch(function(e) {
		});
		activeHouseId = id;
		showHousePlan(id);
	};
	
	var getFlatDetails = function(path, source) {
		var arrayPath = path.split('/');
		var building = arrayPath[0];
		var floor = ~~arrayPath[1];
		var flat = arrayPath[2];
		
		
		hasPlan = false;
		
		if(planData[building] && planData[building].items[floor] && planData[building].items[floor].items[flat]) {
			hasPlan = planData[building].items[floor].items[flat];
		}
		
		$.get(_BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'/'+building+'/flat/'+flat).then(function(responseText) {
			openDetails(path, responseText);
		})
		.catch(function(e) {
		});
		
		if(source !== 'plan') {
			mainPlan.select('building-'+building);
			showWithFlatsPlan(building, function() {
				if(planData[building].hasFloors) {
					withFlatsPlan.select('floor-'+floor);
					showFloorPlan(floor, function() {
						floorPlan.select('flat-'+flat, true);
						if(hasPlan) {
							showFlatPlan(flat);
						} else {
							activeFlatId = flat;
						}
					});
				} else {
					withFlatsPlan.select('flat-'+flat);
					showFlatPlan(flat);
				}
			});
		} else {
			if(floorPlan) {
				floorPlan.select('flat-'+flat);
				if(hasPlan) {
					showFlatPlan(flat);
				} else {
					activeFlatId = flat;
				}
			} else if(withFlatsPlan) {
				withFlatsPlan.select('flat-'+flat);
				activeFlatId = flat;
			}
		}
	};
	
	var initList = function() {
		var $btns = $('.investment-objects__details-button');
		var $tables = $('.investment-objects__table');
		var $btn;
		var $tr;
		
		
		for(var i = 0, s = $btns.length; i < s; ++i) {
			$btn = $($btns[i])
			$tr = $btn.parents('tr');
			
			if(_INVESTMENT_TYPE === 'house') {
				$btn.click(getHouseDetails.bind($btn, $tr.data('name'), 'list'));
			} else if(_INVESTMENT_TYPE === 'withFlats') {
				$btn.click(getFlatDetails.bind($btn, $tr.data('path'), 'list'));
			}
		}
		
		if($tables.length > 0) {
			for(var i = 0, s = $tables.length; i < s; ++i) {
				new Tablesort($tables[i]);
			}
		}
	};
	
	var initSliders = function() {
		var $sliders = $('.investment-filters .filter-slider');
		runSliders($sliders, filterData, filter);
	};
	
	var initSelects = function() {
		var $containers = $('.investment-filters .filter-select');
		var $container;
		var $select;
		for(var i = 0, s = $containers.length; i < s; i++) {
			$container = $($containers[i]);
			$select = $container.find('select');
			$select.change(function(name, event) {
				var val = this.val();
				if(val === '') {
					delete(filterData[name]);
				} else {
					filterData[name] = val;
				}
				filter();
			}.bind($select, $container.data('name')));
		}
	};
	
	var initCheckboxes = function() {
		var $containers = $('.investment-filters .form-checkbox');
		var $container;
		var $checkbox;
		for(var i = 0, s = $containers.length; i < s; i++) {
			$container = $($containers[i]);
			$checkbox = $container.find('input');
			$checkbox.change(function(name, event) {
				var isChecked = this.is(':checked');
				if(false === isChecked) {
					delete(filterData[name]);
				} else {
					filterData[name] = true;
				}
				filter();
			}.bind($checkbox, $container.data('name')));
		}
	};
	
	var filterDataToQuery = function(filterData) {
		var out = [];
		var fieldPrefix = '';
		switch(_INVESTMENT_TYPE) {
			case 'withFlats':
				fieldPrefix = 'flats.';
				break;
			case 'house':
				fieldPrefix = '';
				break;
		}
		
		if(filterData.price) {
			out.push('<'+fieldPrefix+'price>='+filterData.price.from+':'+filterData.price.to);
		}
		
		if(filterData.area) {
			out.push('<'+fieldPrefix+'area>='+filterData.area.from+':'+filterData.area.to);
		}
		
		if(filterData.roomsNumber) {
			out.push('<'+fieldPrefix+'roomsNumber>='+filterData.roomsNumber.from+':'+filterData.roomsNumber.to);
		}
		
		if(filterData.status) {
			out.push(fieldPrefix+'status.status='+filterData.status);
		}
		
		if(filterData.receiptDate) {
			out.push('receiptDate='+filterData.receiptDate);
		}
		
		if(filterData.hasBalcony) {
			out.push(fieldPrefix+'hasBalcony='+filterData.hasBalcony);
		}
		
		if(filterData.hasGarage) {
			out.push(fieldPrefix+'hasGarage='+filterData.hasGarage);
		}
		
		if(filterData.hasGarden) {
			out.push(fieldPrefix+'hasGarden='+filterData.hasGarden);
		}
		
		return out.join(',');
	};
	
	var changeHousesVisibility = function(names) {
		for(var i = 0, s = $filterableJq.length; i < s; ++i) {
			if(-1 === names.indexOf($filterableJq[i].data('name')) ){
				$filterableJq[i].addClass('investment-details-object--hidden');
			} else {
				$filterableJq[i].removeClass('investment-details-object--hidden');
			}
		}
		
		for(var buildingId in planData) {
			var res = (-1 === names.indexOf(buildingId));
			planData[buildingId].hidden = res;
		}
	};
	
	var changeFlatsVisibility = function(response) {
		var paths = [];
		var building;
		var resBuilding;
		var floor;
		var flat;
		var tmp;
		var status;
		for(var i = 0, s = response.length; i < s; ++i) {
			resBuilding = response[i];
			for(var i1 = 0, s1 = resBuilding.flats.length; i1 < s1; ++i1) {
				paths.push(resBuilding.identifier+'/'+resBuilding.flats[i1].floor+'/'+resBuilding.flats[i1].flat);
			}
		}
		
		for(var i = 0, s = $filterableJq.length; i < s; ++i) {
			if(-1 === paths.indexOf($filterableJq[i].data('path')) ){
				$filterableJq[i].addClass('investment-details-object--hidden');
			} else {
				$filterableJq[i].removeClass('investment-details-object--hidden');
			}
		}
		
		for(var buildingId in planData) {
			building = planData[buildingId]
			building.hidden = true;
			building.filterFree = 0;
			building.filterReserved = 0;
			resBuilding = null;
			for(var i = 0, s = response.length; i < s; ++i) {
				resBuilding = response[i];
				if(buildingId == resBuilding.identifier) {
					building.hidden = false;
					break;
				}
			}
			
			for(var floorId in building.items) {
				floor = building.items[floorId];
				floor.hidden = true;
				floor.filterFree = 0;
				floor.filterReserved = 0;
				if(null !== resBuilding) {
					floor.hidden = (-1 === resBuilding.floors.indexOf(~~floorId));
				}
				
				for(var flatId in floor.items) {
					flat = floor.items[flatId];
					flat.hidden = true;
					for(var resFlatRowId in resBuilding.flats) {
						if(resBuilding.flats[resFlatRowId].flat === flatId) {
							flat.hidden = false;
							
							status = floor.items[flatId].status;
							
							if(status === 1) {
								building.filterFree++;
								floor.filterFree++;
							} else if(status === 2) {
								building.filterReserved++;
								floor.filterReserved++;
							}
							
							break;
						}
					}
				}
			}
		}
	};
	
	var filter = function() {
		$.get({
			url: _BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'-filter',
			data: {
				query: filterDataToQuery(filterData)
			}
		})
		.then(function(data) {
			if(_INVESTMENT_TYPE === 'house') {
				changeHousesVisibility(data);
				mainPlan.updateBuildings(planData);
			} else if(_INVESTMENT_TYPE === 'withFlats') {
				changeFlatsVisibility(data);
				mainPlan.updateBuildings(planData);
				if(withFlatsPlan) {
					withFlatsPlan.updateFloors(planData[activeWithFlatsId].items);
				}
				if(floorPlan) {
					floorPlan.updateFlats(planData[activeWithFlatsId].items[activeFloorId].items);
				}
			}
			
			
			if(0 === data.length) {
				$noResults.slideDown();
				$tablesContainer.slideUp();
			} else {
				$tablesContainer.slideDown();
				$noResults.slideUp();
			}
		})
		.catch(function() {
		});
	};
	
	var initFilterable = function() {
		$filterable = $('[data-filterable]');
		for(var i = 0, s = $filterable.length; i < s; ++i) {
			$filterableJq[i] = $($filterable[i]);
		}
		$noResults = $('.investment__no-result');
	};
	
	var initMainPlan = function(callback) {
		var prepareHousesData = function() {
			var out = {
			};
			var $objects = $('.investment-objects .investment-object');
			var sold = $('.investment-objects__table').data('sold');
			var $object;
			var id;
			var $idContainer;
			var $statusContainer;
			var status;
			var $priceContainer;
			var price;
			var $areaContainer;
			var area;
			
			for(var i = 0, s = $objects.length; i < s; ++i) {
				$object = $($objects[i]);
				
				$idContainer = $object.find('.investment-objects__id');
				id = $idContainer.text().trim();
				
				$statusContainer = $object.find('.investment-objects__status');
				status = parseInt($statusContainer.data('value'));
				
				$priceContainer = $object.find('.investment-objects__price');
				price = $priceContainer.html().trim();
				
				$areaContainer = $object.find('.investment-objects__area');
				area = $areaContainer.html().trim();
				
				out[id] = {
					status: status,
					price: price,
					area: area
				};
			}
			
			for(var i = 0, s = sold.length; i < s; ++i) {
				out[sold[i].building] = {
					status: 3
				};
			}
			
			return out;
		};
		
		var prepareFlatsData = function() {
			var out = {
			};
			var $objects = $('.investment-objects .investment-object');
			var sold = $('.investment-objects__table').data('sold');
			var $object;
			var id;
			var $buildingContainer;
			var buildingId;
			var $floorContainer;
			var floorId;
			var $flatContainer;
			var flatId;
			var $statusContainer;
			var status;
			var $priceContainer;
			var price;
			var $areaContainer;
			var area;
			var hasFloors;
			
			for(var i = 0, s = $objects.length; i < s; ++i) {
				$object = $($objects[i]);
				
				$buildingIdContainer = $object.find('.investment-objects__building');
				buildingId = $buildingIdContainer.text().trim();
				
				$floorIdContainer = $object.find('.investment-objects__floor');
				if($floorIdContainer.length > 0) {
					floorId = parseInt($floorIdContainer.text().trim());
					hasFloors = true;
				} else {
					floorId = 0;
					hasFloors = false;
				}
				
				$flatIdContainer = $object.find('.investment-objects__id');
				flatId = $flatIdContainer.text().trim();
				
				$statusContainer = $object.find('.investment-objects__status');
				status = parseInt($statusContainer.data('value'));
				
				$priceContainer = $object.find('.investment-objects__price');
				price = $priceContainer.html().trim();
				
				$areaContainer = $object.find('.investment-objects__area');
				area = $areaContainer.html().trim();
				hasPlan = (1 === parseInt($object.data('has-plan')));
				
				if(!out[buildingId]) {
					out[buildingId] = {
						status: 3,
						items: {},
						free: 0,
						filterFree: null,
						reserved: 0,
						filterReserved: null,
						soldFlats: [],
						hasFloors: hasFloors
					};
				}
				
				if(!out[buildingId].items[floorId]) {
					out[buildingId].items[floorId] = {
						status: 3,
						items: {},
						free: 0,
						filterFree: null,
						reserved: 0,
						filterReserved: null
					};
				}
				
				out[buildingId].items[floorId].items[flatId] = {
					status: status,
					price: price,
					area: area,
					hasPlan: hasPlan
				};
				
				if(status < out[buildingId].items[floorId].status) {
					out[buildingId].items[floorId].status = status;
				}
				
				if(status < out[buildingId].status) {
					out[buildingId].status = status;
				}
				
				if(status === 1) {
					out[buildingId].items[floorId].free++;
					out[buildingId].free++;
				} else if(status === 2) {
					out[buildingId].items[floorId].reserved++;
					out[buildingId].reserved++;
				}
			}
			
			for(var i = 0, s = sold.length; i < s; ++i) {
				buildingId = sold[i].building;
				flatId = sold[i].flat;
				if(!out[buildingId]) {
					out[buildingId] = {
						status: 3,
						items: {},
						free: 0,
						filterFree: null,
						reserved: 0,
						filterReserved: null,
						soldFlats: []
					};
				}
				
				out[buildingId].soldFlats.push(flatId);
			}
			
			return out;
		};
		
		var showPlan = function() {
			mainPlan = new InvestmentPlan($('.investment-plan--interactive'), $plansContainer, 'main');
			
			/*data structure {
				buildingId => {
					status => {1,2,3},
					items => {
						floorId => {
							status: {1,2,3}
							items => {
								status: {1,2,3}
							}
						}
					}
				}
			}
			status:
			1 - free
			2 - reserved
			3 - sold
			*/
			if(_INVESTMENT_TYPE === 'house') {
				planData = prepareHousesData();
				mainPlan.on('buildingClick', function(event, buildingId) {
					removeAllPlans();
					mainPlan.closeMobile();
					getHouseDetails(buildingId);
				});
				mainPlan.updateBuildings(planData);
			} else if(_INVESTMENT_TYPE === 'withFlats') {
				planData = prepareFlatsData();
				mainPlan.on('buildingClick', function(event, buildingId) {
					if(buildingId !== activeWithFlatsId) {
						removeAllPlans();
						closeDetails(true);
						activeFloorId = null;
						activeFlatId = null;
					}
					showWithFlatsPlan(buildingId, null, 'plan');
				});
				mainPlan.updateBuildings(planData);
			}
			
			if(callback) {
				callback();
			}
		};
		
		var loadPlan = function($src) {
			$.get({
				url: $src.data('src'),
				dataType: 'text'
			}).then(function(response) {
				var svg = response.replace('<?xml version="1.0" encoding="UTF-8" standalone="no"?>', '');
				$src.parent().html(svg);
				showPlan();
			});
		};
		
		var $src = $plansContainer.find('.investment-plan__src');
		if($src.length > 0) {
			if($src.prop('tagName').toLowerCase() === 'img') {
				showPlan();
			} else {
				loadPlan($src);
			}
		}
		
	};
	
	var showWithFlatsPlan = function(id, onReady, source) {
		if(activeWithFlatsId === id && withFlatsPlan) {
			activeWithFlatsId = id;
			withFlatsPlan.show();
			if(onReady) {
				onReady();
			}
		} else {
			$.get(_BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'/'+id+'/plan').then(function(responseText) {
				var $new;
				activeWithFlatsId = id;
				$new = $(responseText);
				mainPlan.getContainer().after($new);
				if(withFlatsPlan) {
					removeAllPlans();
				}
				withFlatsPlan = new InvestmentPlan($new, $plansContainer, 'withFlats', function() {
					withFlatsPlan = null;
				});
				withFlatsPlan.on('closeMobile', closeAllPlans);
				withFlatsPlan.on('floorClick', function(event, floorId) {
					if(floorId !== activeFloorId) {
						closeDetails(true);
						activeFlatId = null;
						mainPlan.select('building-'+activeWithFlatsId);
					}
					showFloorPlan(floorId, null, 'plan');
				});
				
				withFlatsPlan.on('flatClick', function(event, flatId) {
					showFlatPlan(flatId, null, 'plan');
					getFlatDetails(activeWithFlatsId+'/'+activeFloorId+'/'+flatId, 'plan');
				});
				
				if(source === 'plan') {
					withFlatsPlan.show();
				}
				
				if(planData[id]) {
					if(false === planData[id].hasFloors) {
						activeFloorId = 0;
						withFlatsPlan.updateFlats(planData[id].items[0].items, planData[activeWithFlatsId].soldFlats);
					} else {
						withFlatsPlan.updateFloors(planData[id].items);
					}
				}
				if(onReady) {
					onReady();
				}
			});
		}
	};
	
	var showFloorPlan = function(id, onReady, source) {
		if(activeFloorId === id && floorPlan) {
			activeFloorId = id;
			floorPlan.show();
			if(onReady) {
				onReady();
			}
		} else {
			$.get(_BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'/'+activeWithFlatsId+'/floor/'+id+'/plan').then(function(responseText) {
				var $new;
				activeFloorId = id;
				$new = $(responseText);
				mainPlan.getContainer().after($new);
				if(floorPlan) {
					floorPlan.destroy();
				}
				floorPlan = new InvestmentPlan($new, $plansContainer, 'floor', function() {
					floorPlan = null;
				}, true);
				floorPlan.on('closeMobile', closeAllPlans);
				floorPlan.on('flatClick', function(event, flatId, isSelected) {
					if(!isSelected) {
						var path = activeWithFlatsId+'/'+activeFloorId+'/'+flatId;
						if(floorPlan) {
							floorPlan.closeMobile();
						}
						if(withFlatsPlan) {
							withFlatsPlan.closeMobile();
						}
						
						activeFlatId = flatId;
						getFlatDetails(path, 'plan');
					} else if(null !== flatPlan) {
						flatPlan.show();
					}
					
				});
				if(planData[activeWithFlatsId].items[activeFloorId]) {
					floorPlan.updateFlats(planData[activeWithFlatsId].items[activeFloorId].items, planData[activeWithFlatsId].soldFlats);
				}
				
				if(source === 'plan') {
					floorPlan.show();
				}
				
				floorPlan.on('hide', showDesktopShowOnPlanBtn);
				
				if(onReady) {
					onReady();
				}
			});
		}
	};
	
	var showFlatPlan = function(id, onReady, source) {
		var hasPlan = false;
		if(planData[activeWithFlatsId] && planData[activeWithFlatsId].items[activeFloorId] && planData[activeWithFlatsId].items[activeFloorId].items[id]) {
			hasPlan = planData[activeWithFlatsId].items[activeFloorId].items[id].hasPlan;
		}
		
		if(true === hasPlan) {
			if(false && activeFlatId === id && flatPlan) {
				activeFlatId = id;
				flatPlan.show();
				if(onReady) {
					onReady();
				}
			} else {
				$.get(_BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'/'+activeWithFlatsId+'/flat/'+id+'/plan').then(function(responseText) {
					var $new;
					activeFlatId = id;
					$new = $(responseText);
					mainPlan.getContainer().after($new);
					if(flatPlan) {
						flatPlan.destroy();
					}
					flatPlan = new InvestmentPlan($new, $plansContainer, 'flat', function() {
						flatPlan = null;
					}, false);
					flatPlan.on('closeMobile', closeAllPlans);
					
					if(source === 'plan') {
						flatPlan.show();
					}
					
					flatPlan.on('hide', showDesktopShowOnPlanBtn);
					
					if(onReady) {
						onReady();
					}
				});
			}
		} else {
			if(flatPlan) {
				flatPlan.destroy();
			}
		}
	};
	
	var showHousePlan = function(id) {
		$.get(_BASE_URL+'/investment/'+_INVESTMENT_UUID+'/'+_INVESTMENT_TYPE+'/'+id+'/plan').then(function(responseText) {
			var $new;
			$new = $(responseText);
			mainPlan.getContainer().after($new);
			mainPlan.select('building-'+id);
			if(housePlan) {
				housePlan.destroy();
			}
			housePlan = new InvestmentPlan($new, $plansContainer, 'house', function() {
				housePlan = null;
			});
			housePlan.on('closeMobile', closeAllPlans);
			housePlan.on('hide', showDesktopShowOnPlanBtn);
		});
	};
	
	var showDesktopShowOnPlanBtn = function() {
		$detailsContainer.find('.investment-details__open-plan-btn--hidden').removeClass('investment-details__open-plan-btn--hidden');
	};
	
	var closeAllPlans = function() {
		mainPlan.close();
		if(housePlan) {
			housePlan.close();
		}
		
		if(withFlatsPlan) {
			withFlatsPlan.close();
		}
		
		if(floorPlan) {
			floorPlan.close();
		}
		
		if(flatPlan) {
			flatPlan.close();
		}
	};
	
	var removeAllPlans = function() {
		if(housePlan) {
			housePlan.destroy();
		}
		
		if(withFlatsPlan) {
			withFlatsPlan.destroy();
		}
		
		if(floorPlan) {
			floorPlan.destroy();
		}
		
		if(flatPlan) {
			flatPlan.destroy();
		}
	};
	
	var showOnPlan = function() {
		window.mainPlan = mainPlan;
		if(_INVESTMENT_TYPE === 'withFlats') {
			
			var showWithFlatsPlanCallback = function() {
				if(withFlatsPlan) {
					withFlatsPlan.show(true);
				} else if(_INVESTMENT_TYPE === 'withFlats') {
					showWithFlatsPlan(activeWithFlatsId, function() {
						withFlatsPlan.show(true);
						withFlatsPlan.select('floor-'+activeFloorId);
					});
				}
				mainPlan.show(true);
				mainPlan.select('building-'+activeWithFlatsId, false);
			};
			
			var showFloorPlanCallback = function() {
				if(floorPlan) {
					floorPlan.show(false, showWithFlatsPlanCallback);
					floorPlan.select('flat-'+activeFlatId);
				} else {
					showFloorPlan(activeFloorId, function() {
						floorPlan.show(false, showWithFlatsPlanCallback);
						floorPlan.select('flat-'+activeFlatId, true);
					});
				}
			}
			
			if(flatPlan) {
				flatPlan.show(false, showFloorPlanCallback);
			} else {
				showFloorPlanCallback();
			}
		} else if(_INVESTMENT_TYPE === 'house') {
			if(housePlan) {
				housePlan.show(false, function() {
					mainPlan.select('building-'+activeHouseId, true);
					mainPlan.show(false);
				});
			}
		}
	};
	
	var initHash = function() {
		var match = window.location.hash.match('details/(.+)');
		if(null !== match) {
			if(_INVESTMENT_TYPE === 'house') {
				getHouseDetails(match[1], 'hash');
			} else if(_INVESTMENT_TYPE === 'withFlats') {
				getFlatDetails(match[1], 'hash');
			}
		}
	};
	
	var updateHash = function(data) {
		window.history.pushState('', '', window.location.pathname+'#/'+data);
	};
	
	if(window._INVESTMENT_TYPE) {
		initFilterable();
		initSliders();
		initSelects();
		initCheckboxes();
		initMap();
		initGallery();
		initList();
		
		initMainPlan(function() {
			initHash();
		});
		
		$(window).on('popstate', initHash);
	}
});
